import {UserRepository} from '../repository/UserRepository';
import {UserStatistics} from '../models/user.model';
import {AppError} from '../../../Data/config/AppError';

export class GetUserStatisticsUseCase {
  private readonly userRepository: UserRepository;

  constructor (userRepository: UserRepository) {
    this.userRepository = userRepository;
  }

  async execute (): Promise<UserStatistics> {
    try {
      // Get user statistics from repository
      const statistics = await this.userRepository.getUserStatistics();

      return statistics;
    } catch (error) {
      // Don't handle error here - just throw it so it can be handled at the component level
      if (error instanceof AppError) {
        throw error;
      }
      throw AppError.fromApiError(error);
    }
  }
}
